export const enum leadConstants {
  listLeadsRequest = 'LIST_LEADS_REQUEST',
  listLeadsSuccess = 'LIST_LEADS_SUCCESS',
  listLeadsFailure = 'LIST_LEADS_FAILURE',

  saveLeadRequest = 'SAVE_LEAD_REQUEST',
  saveLeadSuccess = 'SAVE_LEAD_SUCCESS',
  saveLeadFailure = 'SAVE_LEAD_FAILURE',

  viewLeadRequest = 'VIEW_LEAD_REQUEST',
  viewLeadSuccess = 'VIEW_LEAD_SUCCESS',
  viewLeadFailure = 'VIEW_LEAD_FAILURE',

  updateLeadRequest = 'UPDATE_LEAD_REQUEST',
  updateLeadSuccess = 'UPDATE_LEAD_SUCCESS',
  updateLeadFailure = 'UPDATE_LEAD_FAILURE',

  deleteLeadRequest = 'DELETE_LEAD_REQUEST',
  deleteLeadSuccess = 'DELETE_LEAD_SUCCESS',
  deleteLeadFailure = 'DELETE_LEAD_FAILURE',

  addFollowUpRequest = 'ADD_FOLLOWUP_REQUEST',
  addFollowUpSuccess = 'ADD_FOLLOWUP_SUCCESS',
  addFollowUpFailure = 'ADD_FOLLOWUP_FAILURE',
}
